import { Component } from 'react';

import { ISubCategory } from '../../../../../../domain/model/category/ICategoryRepository';
import { WebCategory } from '../../../../../../domain/model/category/WebCategory';
import { ViewType, ContentIdType } from '../../../../../../domain/model/newsfeed/INewsFeedRepository';
import Button from '../../../../pc/common/components/js/modules/Button';
import FeedLoadMoreButton from '../../../../pc/common/components/js/modules/FeedLoadMoreButton';
import FeedAdItem from '../../../common/components/js/feedItems/FeedAdItem';
import { IAdItem, INewsFeedItem, INewsFeedExperiment } from '../../store/newsFeed';
import ModuleError from '../../../common/components/js/modules/ModuleError';
import FeedArticleItem from '../../../common/components/js/feed/FeedArticleItem';
import NewsFeedItem from '../../../common/components/js/newsFeed/NewsFeed';
import { NewsFeedTitle } from '../../../common/components/js/newsFeed/NewsFeedTitle';

interface IProps {
  items: ReadonlyArray<INewsFeedItem | IAdItem>;
  articleCount: number;
  displayCount: number;
  isLimit: boolean;
  fetch: () => void;
  fetchMore: () => void;
  setIsOpenDislikePopUp: (contentId: string, isOpenDislikePopUp: boolean) => void;
  reflectStorage?: () => void;
  reflectLocalStorage?: () => void;
  isError: boolean;
  isErrorOnClient: boolean;
  category?: WebCategory;
  currentSubCategory?: ISubCategory;
  isMajor: boolean; // 主要タブであるか
  yadsAdDsId: string;
  experimentId?: string;
  bucketId?: string;
  mtestid?: string;
  experiments?: Array<INewsFeedExperiment>;
  yadsTypeTag?: string;
  isFetching: boolean;
  isFetchingFirst: boolean;
  ualElementId?: string;
  updateFeedForDislike?: () => void;
  addDislike?: (contentId: string) => void;
  removeDislike?: (contentId: string) => void;
  isFetchingForDislike: boolean;
  categoryId: string;
}

interface IStates {
  isClickLoadMoreButton: boolean;
}

export default class NewsFeed extends Component<IProps, IStates> {
  private ulistElement: HTMLUListElement | null = null;

  constructor(props: IProps) {
    super(props);
    this.state = {
      isClickLoadMoreButton: false
    };
  }

  /**
   *
   */
  public componentDidMount() {
    // SessionStorageに格納してあるFeed情報を取得
    if (this.props.reflectStorage) {
      this.props.reflectStorage();
    }
    // 主要タブの場合のみタイムラインからDISLIKEされた記事を取り除いて整形しなおす
    if (this.props.isMajor && this.props.updateFeedForDislike) {
      this.props.updateFeedForDislike();
    }
    // LocalStorageに格納してあるコメントのフラグ情報を取得
    if (this.props.isMajor && this.props.reflectLocalStorage) {
      this.props.reflectLocalStorage();
    }

    // feed部分が画面に入り次第初回読み込みができるようにイベントListenerに追加
    window.addEventListener('scroll', this.loadFirstIfInView);
    // すでに画面に表示されている可能性があるので呼び出す
    this.loadFirstIfInView();

    // UALトラッキングモジュールを初期化
    this.initUAL();
  }

  /**
   * @param prevProps
   */
  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.displayCount !== this.props.displayCount) {
      this.setState({ isClickLoadMoreButton: false });
    }
    if (window.customLogger) {
      if (window.customLogger.isTargetModule('wrapper')) {
        window.customLogger.refreshModule('wrapper');
      } else {
        window.customLogger.addModules('wrapper', false, { logViewWithoutLinks: false });
      }
    }

    this.reinitializeUAL();

    if (this.props.currentSubCategory && !prevProps.currentSubCategory) {
      window.addEventListener('scroll', this.loadFirstIfInView);
      this.loadFirstIfInView();
      return;
    }
  }

  /**
   *
   */
  public render() {
    const titleHeader = this.props.isMajor ? <NewsFeedTitle>あなたにおすすめ</NewsFeedTitle> : null;

    // 主要タブはDISLIKEの整形処理が実行されるまではスケルトン表示にする
    if (this.props.isMajor && !this.props.isFetchingForDislike) {
      // 見出しとskeletonScreenの表示が被らないようにdivとclass指定の構成を変更して描画
      return (
        <div id="newsFeed">
          {titleHeader}
          <NewsFeedItem isLoading={false} />
        </div>
      );
    }

    // 初回読み込みでエラー
    if (this.props.isError && this.props.items.length === 0) {
      return (
        <div id="newsFeed" className="newsFeed">
          {titleHeader}
          {this.getErrorModuleElement(this.props.isErrorOnClient, true)}
        </div>
      );
    }

    const loadMoreButton = !this.props.isLimit ? (
      <FeedLoadMoreButton
        isFetching={this.state.isClickLoadMoreButton}
        loadMore={() => {
          this.setState({ isClickLoadMoreButton: true });
          this.props.fetchMore();
        }}
      />
    ) : null;

    let commentCount: number = 1;
    let dislikeCount: number = 1; // DISLIKE用pos
    const items: Array<JSX.Element | null> = this.props.items
      .filter((item, num) => num < this.props.displayCount)
      .map((item, index) => {
        // 方針: APIリクエスト時にデバイス情報をパラメータで持たせる
        // 細かい動画出しわけなどはUAから判定する
        const position = index + 1;
        switch (item.viewType) {
          case ViewType.ARTICLE:
          case ViewType.ARTICLE_WIDE: {
            // ここに入るときはINewsFeedItem型で定義している前提
            const article = item as INewsFeedItem;
            const contentId = article.contentId || '';
            const contentIdType = article.contentIdType || '';
            const sec = this.getSecByCategory(this.props.category, this.props.currentSubCategory) || '';
            const slk = article.ultSlk || 'title';
            const ualElementId = this.props.ualElementId || '';
            // timelineバケットを埋め込む
            const mtestParams: string[] = [];
            if (this.props.experiments) {
              this.props.experiments.forEach(experiment => {
                mtestParams.push(`${experiment.experimentId}=${experiment.bucketId}`);
              });
            }
            const mtestParam = mtestParams.length !== 0 ? `mtestid:${mtestParams.join('&')};` : '';
            const commentItemNumber = article.isCommentModule ? commentCount++ : null;

            // DISLIKEボタンを表示する対象かどうか(=主要タブかつShannonContentIDがある)
            // 現状オーサーコメント棚出し用のFeedではShannonContentIDがデータに無い&取得元がタイムラインAPIではない
            // そのためDISLIKEボタンの表示対象外とする(ContentIDのチェックだけで弾けるが念のためisAuthorCommentModuleも判定に含める)
            const isShowDislikeModule =
              this.props.isMajor &&
              article.contentId !== undefined &&
              article.contentIdType !== undefined &&
              article.contentIdType === ContentIdType.SHANNON_ARTICLE &&
              !article.isAuthorCommentModule;

            // DISLIKE用のpos
            const dislikeItemNumber = isShowDislikeModule ? dislikeCount++ : null;

            return (
              <FeedArticleItem
                {...article}
                isShowDateTime={true}
                key={article.link}
                dataClParams={`_cl_vmodule:${sec};_cl_link:${slk};_cl_position:${position};`}
                viewableDataClParams={`_cl_vmodule:v_ntoptl;_cl_link:stream;_cl_position:${position};`}
                dataUal={`content_id:${contentId};id_type:${contentIdType};element_id:${ualElementId};opttype:pc;service:news;apptype:web;${mtestParam}`}
                isShowComment={false}
                articleViewablePos={position}
                commentViewablePos={commentItemNumber}
                addDislikeForChild={() =>
                  isShowDislikeModule && this.props.addDislike && article.contentId
                    ? this.props.addDislike(article.contentId)
                    : null
                }
                removeDislikeForChild={() =>
                  isShowDislikeModule && this.props.removeDislike && article.contentId
                    ? this.props.removeDislike(article.contentId)
                    : null
                }
                isShowDislikeModule={isShowDislikeModule}
                dislikeModulePos={dislikeItemNumber}
                // 主要タブのみコメント件数を掲出
                showCommentCount={this.props.isMajor}
                isNewsFeedItemRelative={true}
                setIsOpenDislikePopUp={this.props.setIsOpenDislikePopUp}
                isFetchedExpertRecommendArticles={false}
              />
            );
          }
          case ViewType.AD_INFEED: {
            // 広告用につかうID
            const keyId = this.props.currentSubCategory ? this.props.currentSubCategory.id : '';
            return (
              <FeedAdItem
                key={`ad_${keyId}_${index}`}
                itemNumber={index}
                yadsAdDsId={this.props.yadsAdDsId}
                yadsTypeTag={this.props.yadsTypeTag}
                categoryId={this.props.categoryId}
              />
            );
          }
        }
        return null;
      });

    // 追加読み込み時のエラー
    if (this.props.isError && this.props.items.length > 0 && !this.props.isLimit) {
      return (
        <div id="newsFeed" className="newsFeed">
          {titleHeader}
          <ul className="newsFeed_list" ref={ulistElement => (this.ulistElement = ulistElement)}>
            {items}
          </ul>
          {this.getErrorModuleElement(this.props.isErrorOnClient, false)}
        </div>
      );
    }

    return (
      <NewsFeedItem id="newsFeed" isLoading={this.props.isFetchingFirst}>
        {titleHeader}
        <ul className="newsFeed_list" ref={ulistElement => (this.ulistElement = ulistElement)}>
          {items}
        </ul>
        {loadMoreButton}
      </NewsFeedItem>
    );
  }

  /**
   * UALのトラッキングモジュールを初期化する
   */
  private initUAL = () => {
    if (window?.ual && typeof window.ual === 'function') {
      window.ual('init', 'newsFeed');
      window.ual('ctrl', 'start');
    }
  };

  /**
   * UALのトラッキングモジュールを終了する
   */
  private deinitUAL = () => {
    if (window?.ual && typeof window.ual === 'function') {
      window.ual('deinit', 'newsFeed');
    }
  };

  /**
   * UALのトラッキングモジュールを再初期化する
   */
  private reinitializeUAL = () => {
    this.deinitUAL();
    this.initUAL();
  };

  /**
   * Feedが画面内に存在すれば初回読み込みのActionを発火する
   */
  private loadFirstIfInView = () => {
    if (this.props.items.length > 0) {
      // session復元などですでにlistがある場合、fetchをせずリスナーだけ取り除く
      window.removeEventListener('scroll', this.loadFirstIfInView);
      return;
    }

    if (this.checkFeedInView()) {
      // 読み込み処理を呼び出したので、scrollのイベントリスナーを取り除く
      window.removeEventListener('scroll', this.loadFirstIfInView);
      this.props.fetch();
      return;
    }
  };

  /**
   * ブラウザの高さとFeedの配置情報から画面内に存在するか判定
   */
  private checkFeedInView = (): boolean => {
    if (this.ulistElement === null) {
      return false;
    }
    const feedRect = this.ulistElement.getBoundingClientRect();
    if (feedRect === null) {
      return false;
    }
    const feedIsViewIn = feedRect.top - window.innerHeight < 0;
    return feedIsViewIn;
  };
  /**
   * WebCategoryより、sec文字列を取得
   * 該当するものがなかったときはundefined
   *
   * @param category  WebCategory
   * @param subCategory
   * @returns string
   */
  private getSecByCategory(category?: WebCategory, subCategory?: ISubCategory): string | undefined {
    if (!category) {
      return undefined;
    }
    // 主要のときは、一律st_maj
    if (category === WebCategory.MAJOR) {
      return 'st_maj';
    }
    if (!subCategory) {
      return undefined;
    }
    if (subCategory.id !== 'new') {
      return `st_${subCategory.id}`;
    }
    // 主要以外のタブでは、サブカテゴリによって変更する
    switch (category) {
      case WebCategory.DOMESTIC:
        return 'st_n_dom';
      case WebCategory.WORLD:
        return 'st_n_wor';
      case WebCategory.BUSINESS:
        return 'st_n_bus';
      case WebCategory.ENTERTAINMENT:
        return 'st_n_ent';
      case WebCategory.SPORTS:
        return 'st_n_spo';
      case WebCategory.IT:
        return 'st_n_it';
      case WebCategory.SCIENCE:
        return 'st_n_sci';
      case WebCategory.LIFE:
        return 'st_n_lif';
      case WebCategory.LOCAL:
        return 'st_n_loc';
    }
    return undefined;
  }
  private getErrorModuleElement(isErrorOnClient: boolean, isFetchFirst: boolean): JSX.Element {
    return (
      <ModuleError
        title="記事を表示できませんでした。"
        explain="しばらく時間をおいて再度お試しください。"
        additionalComponent={
          <Button
            text="更新する"
            type="simple"
            isDisabled={false}
            onClick={() => {
              if (this.props.isMajor) {
                // 主要PCでエラーモジュール表示時はが画面をリロードする
                location.reload();
                return;
              }

              if (isErrorOnClient) {
                // クライアント側のときは、画面をリロードさせる
                location.reload();
              } else {
                // サーバーサイドエラーの場合は、APIに再アクセス
                isFetchFirst ? this.props.fetch() : this.props.fetchMore();
              }
            }}
            useAnchorTag={false}
          />
        }
      />
    );
  }
}
